import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { ToastrService } from "ngx-toastr";
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { Bundle } from '../../interfaces/bundles/bundle';
import { BundleForCreation } from '../../interfaces/bundles/bundle-for-creation';
import { SelectOption } from '../../interfaces/select-option';
import { map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BundlesRepositoryService extends PaginatedRepository<Bundle> {
    protected override _baseLink: string;

    constructor(
        http: HttpClient,
        messageService: ToastrService,
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
        super(
            http,
            messageService);

        this._baseLinkTemplate = `${this.config.rootUrl}/Corporations/[0]/Bundles`;
        this._baseLink = `${this.config.rootUrl}/Bundles`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }
    }

    public getBundle = (bundleID: string) => {
        return this.http.get<Bundle>(`${this._baseLink}/${bundleID}`);
    }

    public createBundle = (bundle: BundleForCreation) => {
        return this.http.post<Bundle>(this._baseLink, bundle);
    }

    public deleteBundle = (bundleID: string) => {
        return this.http.delete<Bundle>(`${this._baseLink}/${bundleID}`);
    }

    public getBundlesAsSelectOptions = (corporationID: string) => {
        return this.getUBundles(corporationID).pipe(map(types => types.map(this.mapUserBundlesToSelectOption)));
    }

    private getUBundles = (corporationID: string) => {
        this.populateBaseLink([corporationID]);

        let params = new HttpParams().set("PageSize", 100).set("SortColum", "Name").set("IsVisible", true);

        return this.http.get<Bundle[]>(this._baseLink, { params: params });
    }

    private mapUserBundlesToSelectOption(type: Bundle): SelectOption {
        return { label: type.name, value: type.id };
    }
}